// extracted by mini-css-extract-plugin
export default {"wrapper":"IqosMasterclass_wrapper__fRlRx","slideContainer":"IqosMasterclass_slideContainer__1zQTc"};